import cx from 'classnames';
import type { ReactChild } from 'react';
import React from 'react';

import Tooltip from './../../../../wix-rich-content-common/lib/Tooltip';

import styles from './ToolbarButton-scss';

type ToolbarButtonProps = {
  isMobile?: boolean;
  active?: boolean;
  disabled?: boolean;
  onClick: (e: $TSFixMe) => void;
  dataHook?: string;
  children: ReactChild;
  tooltip?: string;
};

const ToolbarButton = React.forwardRef<HTMLButtonElement | null, ToolbarButtonProps>(
  ({ isMobile = false, active, disabled, children, onClick, dataHook, tooltip }, ref) => {
    return (
      <Tooltip key={tooltip} content={tooltip} tooltipOffset={{ x: 0, y: -8 }}>
        <button
          aria-label={tooltip}
          disabled={disabled}
          ref={ref}
          className={cx(styles.toggleButtonWrapper, {
            [styles.mobileToggleButtonWrapper]: isMobile,
            [styles.active]: active,
          })}
          onClick={onClick}
          onMouseDown={e => e.preventDefault()}
          data-hook={dataHook}
          type="button"
        >
          <div
            className={cx(styles.toggleButton, {
              [styles.mobileToggleButton]: isMobile,
            })}
          >
            {children}
          </div>
        </button>
      </Tooltip>
    );
  }
);

export default ToolbarButton;
